import { useFrame } from "@react-three/fiber";
import { Interactive, useController } from "@react-three/xr";
import React from "react";
import * as THREE from "three";
import { useCursorShrinkingStore } from "../UI/CursorNew";
import { useXRPopupStore } from "../Popups/XRHotspots";
import { Center } from "@react-three/drei";

const CloseBtn = (props: { scale: number }) => {
  const [hovered, setHovered] = React.useState<boolean>(false);
  const matRef = React.useRef<THREE.MeshBasicMaterial>(null);

  const { scale } = props;

  const gaze = useController("none");

  const cursor = useCursorShrinkingStore();

  const xrPop = useXRPopupStore();

  useFrame(() => {
    if (matRef.current) {
      if (hovered) {
        index.lerp(end, 0.3);
        matRef.current.opacity = index.x;
      } else {
        index.lerp(start, 0.3);
        matRef.current.opacity = index.x;
      }
    }
  });

  return (
    <>
      <Interactive
        onHover={() => {
          clearTimeout(timeout);

          clearTimeout(timeout2);
          cursor.setShrinking(false);
          setHovered(true);

          if (gaze) {
            timeout = setTimeout(() => {
              cursor.setShrinking(true);
              timeout2 = setTimeout(() => {
                xrPop.closePop();
                cursor.setShrinking(false);
                clearTimeout(timeout);
                clearTimeout(timeout2);
              }, 2e3);
            }, 1e3);
          }
        }}
        onBlur={() => {
          cursor.setShrinking(false);
          clearTimeout(timeout);
          clearTimeout(timeout2);
          setHovered(false);
        }}
        onSelect={xrPop.closePop}
      >
        <Center onUpdate={(self) => self.lookAt(0, 0, 0)} scale={scale}>
          <mesh geometry={circle} renderOrder={3} name="hotspot">
            {/* <meshNormalMaterial></meshNormalMaterial> */}
            <meshBasicMaterial
              ref={matRef}
              color={"white"}
              // opacity={0.5}
              // wireframe
              transparent
              depthTest={false}
            />
          </mesh>

          <group scale={0.1} rotation={[0, 0, -Math.PI / 4]}>
            {crossMesh}
          </group>
        </Center>
      </Interactive>
    </>
  );
};

export default CloseBtn;

const index = new THREE.Vector2();
const start = new THREE.Vector2(0, 0);
const end = new THREE.Vector2(0.5, 0);
let timeout: NodeJS.Timeout;
let timeout2: NodeJS.Timeout;

const circle = new THREE.CircleGeometry(1.5, 16);
const cross = new THREE.PlaneGeometry(20, 2);

const crossMaterial = new THREE.MeshBasicMaterial({
  depthTest: false,
  color: "white",
  transparent: true,
});

const crossMesh = (
  <group scale={0.9}>
    <mesh geometry={cross} renderOrder={4} material={crossMaterial}></mesh>
    <mesh
      material={crossMaterial}
      geometry={cross}
      rotation={[0, 0, Math.PI / 2]}
      renderOrder={4}
    ></mesh>
  </group>
);
